export const CONFIG = {
  businessName: 'BODY SCIENCE REHAB',
  therapistName: 'Dr. Priyanshu Chouhan',
  location: 'Jodhpur, Rajasthan',
  phone: '+91-8209229099',
  email: 'bodysciencerehab@gmail.com',
  whatsappNumber: '918209229099',
  address: '25-E-30, Near Indigo Public School, C.H.B, Jodhpur (Rajasthan), 342009',
  googleMapsUrl: 'https://maps.app.goo.gl/bMdh7v9cXCZbEYu48',
  iapRegNo: '51353',
  qualifications: 'BPT, MPT (Neurological Rehabilitation), MIAP, CDNT, CDCT, CSTT, CIAFMT',
  googleFormEmbedUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfKtCsPjDeRaSp7ckX_atU-SMHf3ZpZVz2JiJ_twAYqQTQ9FA/viewform?embedded=true', // Google Form for appointment booking (https://forms.gle/jjanQf5RfeTdy3uC8)
  socialMedia: {
    facebook: 'https://facebook.com/bodysciencerehab',
    instagram: 'https://instagram.com/bodysciencerehab',
    linkedin: 'https://linkedin.com/company/bodysciencerehab',
    youtube: 'https://youtube.com/bodysciencerehab'
  },
  timings: {
    weekdays: 'Monday - Saturday: 9 AM - 1:30 PM / 4 PM - 8 PM',
    sunday: 'Sunday: Closed / Appointment'
  }
}

export const EXERCISES = [
  { id: 1, name: 'Chin Tucks', bodyPart: 'neck', difficulty: 'Easy', duration: '3 min', description: 'Gently retract the chin to align ears over shoulders.' },
  { id: 2, name: 'Upper Trapezius Stretch', bodyPart: 'neck', difficulty: 'Easy', duration: '4 min', description: 'Tilt head to the side to stretch opposite upper trapezius.' },
  { id: 3, name: 'Pendulum Exercise', bodyPart: 'shoulder', difficulty: 'Easy', duration: '5 min', description: 'Lean forward and let the arm dangle, small circles.' },
  { id: 4, name: 'Wall Slides', bodyPart: 'shoulder', difficulty: 'Medium', duration: '5 min', description: 'Slide forearms up the wall keeping core engaged.' },
  { id: 5, name: 'Cat-Camel Stretch', bodyPart: 'back', difficulty: 'Easy', duration: '4 min', description: 'Alternate spinal flexion and extension on all fours.' },
  { id: 6, name: 'Quad Sets', bodyPart: 'knee', difficulty: 'Easy', duration: '3 min', description: 'Tighten thigh muscle with leg straight, hold and release.' },
  { id: 7, name: 'Ankle Alphabet', bodyPart: 'ankle', difficulty: 'Easy', duration: '5 min', description: 'Trace the alphabet with your foot to mobilize the ankle.' },
  { id: 8, name: 'Hip Flexor Stretch', bodyPart: 'hip', difficulty: 'Medium', duration: '4 min', description: 'Lunge position to stretch hip flexors.' },
  { id: 9, name: 'Wrist Flexor Stretch', bodyPart: 'wrist', difficulty: 'Easy', duration: '3 min', description: 'Extend arm and gently pull fingers back.' },
  { id: 10, name: 'Tennis Elbow Stretch', bodyPart: 'elbow', difficulty: 'Easy', duration: '4 min', description: 'Extend arm and gently pull wrist down.' }
]

export const TEAM_MEMBERS = [
  {
    id: 1,
    name: 'Dr. Priyanshu Chouhan',
    title: 'Consultant Physiotherapist & Founder',
    bio: 'Highly qualified physiotherapist with extensive experience in Neurological Rehabilitation, Orthopedic Conditions and Sports injury Rehabilitation. Specializes in Cupping Therapy, Dry Needling Therapy, Sports Taping, Electrotherapy and Manual Therapy Techniques.',
    qualifications: 'BPT, MPT (Neurological Rehabilitation), MIAP, CDNT, CDCT, CSTT, CIAFMT\nMember of Indian Association of Physiotherapist',
    image: '/photo.png'
  }
]

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Akansha Sharma',
    role: 'Patient',
    location: 'Jodhpur',
    text: 'I had an amazing experience at Body Science Rehab! The physiotherapist took the time to understand my pain and provided a personalized treatment plan that worked wonders. After just a few sessions, I noticed a significant improvement in my mobility and pain relief.',
    image: 'https://ui-avatars.com/api/?name=Akansha+Sharma&background=0ea5e9&color=fff'
  },
  {
    id: 2,
    name: 'Chinmay Bohra',
    role: 'Patient',
    location: 'Jodhpur',
    text: 'I suffered from ligament injury of ankle and taken the rehab at Body Science Rehab. After my treatment was completely done, I have attained full recovery. When I came to clinic I was not able to walk properly, but after the treatment I am completely fine now.',
    image: 'https://ui-avatars.com/api/?name=Chinmay+Bohra&background=10b981&color=fff'
  },
  {
    id: 3,
    name: 'Veena Sakhrani',
    role: 'Patient',
    location: 'Jodhpur',
    text: 'I am really very thankful to Dr. Priyanshu. When I was suffering with my shoulder issues, my orthopedic doctor told me that I am having rotator cuff tear and I suffered for 4 months. When I met with you and taken your treatment, I got relief and now I am much better.',
    image: 'https://ui-avatars.com/api/?name=Veena+Sakhrani&background=f59e0b&color=fff'
  },
  {
    id: 4,
    name: 'Mayank Golani',
    role: 'Patient',
    location: 'Jodhpur',
    text: 'I visited Dr. Priyanshu Chouhan at Body Science Rehab in Jodhpur for a consultation regarding muscle spasm. He was very polite, listened carefully, and explained everything in simple words. I felt comfortable and well-guided. Highly recommended!',
    image: 'https://ui-avatars.com/api/?name=Mayank+Golani&background=8b5cf6&color=fff'
  }
]

export const BLOG_POSTS = [
  {
    id: 1,
    title: '5 Essential Exercises for Better Posture',
    excerpt: 'Learn simple exercises you can do at home to improve your posture and reduce back pain...',
    date: 'March 15, 2024',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
    category: 'Exercise'
  },
  {
    id: 2,
    title: 'Preventing Sports Injuries: A Complete Guide',
    excerpt: 'Discover effective strategies to prevent common sports injuries and maintain peak performance...',
    date: 'March 10, 2024',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
    category: 'Sports'
  },
  {
    id: 3,
    title: 'Workplace Ergonomics: Setting Up Your Home Office',
    excerpt: 'Essential tips for creating an ergonomic workspace that promotes health and productivity...',
    date: 'March 5, 2024',
    image: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
    category: 'Ergonomics'
  },
  {
    id: 4,
    title: 'The Science of Recovery: Why Rest Matters',
    excerpt: 'Understanding the physiological processes of recovery and how to optimize your healing...',
    date: 'February 28, 2024',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
    category: 'Recovery'
  }
]
